import React from 'react';

import Text from '../text';

import { Tag as Props, variants, sizes } from './tag.types';
import classNames from 'classnames';

const Tag: React.FunctionComponent<Props> & {
  sizes: typeof sizes;
  variants: typeof variants;
} = ({ text, icon, border, size = sizes.m, variant = variants.primary }) => (
  <Text
    size={size}
    tight
    className={classNames('tag', `tag--variant-${variant}`, {
      [`tag--variant-${variant}-border`]: border,
    })}
  >
    {icon ? icon : null}
    {text}
  </Text>
);

Tag.sizes = sizes;
Tag.variants = variants;
export default Tag;
